import version from '../common/version';
import { isScopedAttributeDisabled } from './createElement';
import { isBrowser } from './helper';
var bundledBy = '1';
var StyleRegistryManage = (function () {
    function StyleRegistryManage() {
        var globalObj = (isBrowser ? window : global);
        globalObj.__dui_style_registry__ = globalObj.__dui_style_registry__ || {};
        this.registry = globalObj.__dui_style_registry__;
    }
    Object.defineProperty(StyleRegistryManage.prototype, "length", {
        get: function () {
            return Object.keys(this.registry).length;
        },
        enumerable: false,
        configurable: true
    });
    StyleRegistryManage.prototype.set = function (key, bundledsBy) {
        this.registry[key] = bundledsBy;
    };
    StyleRegistryManage.prototype.get = function (key) {
        return this.registry[key];
    };
    StyleRegistryManage.prototype.add = function (key, bundledBy) {
        if (!this.registry[key]) {
            this.registry[key] = [];
        }
        this.registry[key].push(bundledBy);
    };
    return StyleRegistryManage;
}());
var styleRegistryManage = new StyleRegistryManage();
export function injectStyle(fileKey, css) {
    var key = version + "-" + fileKey;
    var domKey = isScopedAttributeDisabled ? fileKey : key;
    var hasElement = Boolean((isBrowser && document.querySelector("style[data-dui-key=\"" + domKey + "\"]")) || !isBrowser);
    if (Array.isArray(styleRegistryManage.get(key)) && hasElement) {
        styleRegistryManage.add(key, bundledBy);
        warnRedundantInject(key);
        return;
    }
    styleRegistryManage.set(key, [bundledBy]);
    var versions = getFileVersions(fileKey);
    if (versions.length > 1) {
        warnMultipleVersions(fileKey, versions);
    }
    if (isBrowser) {
        var styleElement = document.createElement('style');
        styleElement.setAttribute('type', 'text/css');
        styleElement.setAttribute('data-dui-key', domKey);
        styleElement.innerText = css;
        document.head.appendChild(styleElement);
    }
    else if (typeof injectContentBeforeRoot === 'function') {
        var styleElement = "<style type=\"text/css\" data-dui-key=\"" + domKey + "\">" + css + "</style>";
        injectContentBeforeRoot(styleElement);
    }
}
var CONSOLE_DEBOUNCE = 3000;
function warnRedundantInject(key) {
    if (!isBrowser || !styleRegistryManage.length || !Array.isArray(styleRegistryManage.get(key))) {
        return;
    }
    var count = styleRegistryManage.get(key).length;
    setTimeout(function () {
        if (styleRegistryManage.get(key).length > count) {
            return;
        }
        console.warn("[DUI] " + key + " \u91CD\u590D\u5F15\u5165\u4E86 " + count + " \u6B21");
    }, CONSOLE_DEBOUNCE);
}
function warnMultipleVersions(fileKey, versions) {
    if (!isBrowser) {
        return;
    }
    setTimeout(function () {
        if (getFileVersions(fileKey).length > versions.length) {
            return;
        }
        console.warn("[DUI] " + fileKey + " \u5B58\u5728\u591A\u4E2A\u7248\u672C:  " + versions.join('  '));
    }, CONSOLE_DEBOUNCE);
}
function getFileVersions(fileKey) {
    if (!styleRegistryManage.length) {
        return [];
    }
    var existingKeys = Object.getOwnPropertyNames(styleRegistryManage.registry);
    return existingKeys.filter(function (k) { return k.indexOf(fileKey) !== -1; }).map(function (k) { return k.split('-')[0]; });
}
